module.exports = __webpack_public_path__ + "img/ontario-150.650934a8.svg";